export const moveToFolder = "m1WMYd";
export default {moveToFolder};